/** @module InciList */

/**
 * A description of a bottle's content.
 *
 * @typedef {Object} InciList
 * @property {string} usage
 * @property {string[]} active
 * @property {string[]} inactive
 * @property {string[]} excipients
 */

/**
 * InciList constructor.
 *
 * @function
 * @param {string|null} usage
 * @param {string[]|null} active
 * @param {string[]} inactive
 * @param {string[]} [excipients]
 * @return {InciList}
 */
export const InciList = (usage, active, inactive, excipients) => ({
  usage,
  active,
  inactive,
  excipients: excipients || []
});

/**
 * Get usage from inci list.
 *
 * @function
 * @param {InciList} inciList
 * @return {string}
 */
export const getInciListUsage = inciList => inciList.usage;

/**
 * Get active ingredients from inci list.
 *
 * @function
 * @param {InciList} inciList
 * @return {string[]}
 */
export const getInciListActiveIngredients = inciList => inciList.active || [];

/**
 * Get inactive ingredients from inci list.
 *
 * @function
 * @param {InciList} inciList
 * @return {string[]}
 */
export const getInciListInactiveIngredients = inciList => inciList.inactive;

/**
 * Get a list of excipients from ici list.
 *
 * @function
 * @param {InciList} inciList
 * @return {string[]}
 */
export const getInciListExcipients = inciList => inciList.excipients;
